export default __webpack_public_path__ + "static/media/google-logo.78998f2b.png";